'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFa = require('react-fa');

var _advisors = require('./advisors');

var _advisors2 = _interopRequireDefault(_advisors);

var _allProject = require('./allProject');

var _allProject2 = _interopRequireDefault(_allProject);

var _card = require('./card');

var _card2 = _interopRequireDefault(_card);

var _favorites = require('./favorites');

var _favorites2 = _interopRequireDefault(_favorites);

var _info = require('./info');

var _info2 = _interopRequireDefault(_info);

var _logOut = require('./logOut');

var _logOut2 = _interopRequireDefault(_logOut);

var _members = require('./members');

var _members2 = _interopRequireDefault(_members);

var _myProject = require('./myProject');

var _myProject2 = _interopRequireDefault(_myProject);

var _dashboard = require('./dashboard');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _bell = require('./bell');

var _bell2 = _interopRequireDefault(_bell);

var _gear = require('./gear');

var _gear2 = _interopRequireDefault(_gear);

var _user = require('./user');

var _user2 = _interopRequireDefault(_user);

var _CheckIconFilled = require('./CheckIconFilled');

var _CheckIconFilled2 = _interopRequireDefault(_CheckIconFilled);

var _LogoTextOnly = require('./LogoTextOnly');

var _LogoTextOnly2 = _interopRequireDefault(_LogoTextOnly);

var _NoProjectsIcon = require('./NoProjectsIcon');

var _NoProjectsIcon2 = _interopRequireDefault(_NoProjectsIcon);

var _WalletIcon = require('./WalletIcon');

var _WalletIcon2 = _interopRequireDefault(_WalletIcon);

var _LoupeIcon = require('./LoupeIcon');

var _LoupeIcon2 = _interopRequireDefault(_LoupeIcon);

var _HandBag = require('./HandBag');

var _HandBag2 = _interopRequireDefault(_HandBag);

var _LikeIcon = require('./LikeIcon');

var _LikeIcon2 = _interopRequireDefault(_LikeIcon);

var _StarIcon = require('./StarIcon');

var _StarIcon2 = _interopRequireDefault(_StarIcon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Fa =
/*#__PURE__*/
function (_react$Component) {
  _inherits(Fa, _react$Component);

  function Fa() {
    _classCallCheck(this, Fa);

    return _possibleConstructorReturn(this, _getPrototypeOf(Fa).apply(this, arguments));
  }

  _createClass(Fa, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          name = _this$props.name,
          className = _this$props.className,
          size = _this$props.size,
          rotate = _this$props.rotate,
          flip = _this$props.flip,
          fixedWidth = _this$props.fixedWidth,
          spin = _this$props.spin,
          pulse = _this$props.pulse,
          stack = _this$props.stack,
          inverse = _this$props.inverse;
      return _react2.default.createElement(_reactFa.Icon, {
        style: style,
        name: name,
        className: className,
        size: size,
        rotate: rotate,
        flip: flip,
        fixedWidth: fixedWidth,
        spin: spin,
        pulse: pulse,
        stack: stack,
        inverse: inverse
      });
    }
  }]);

  return Fa;
}(_react.Component);

exports.default = {
  Fa: Fa,
  advisors: _advisors2.default,
  allProject: _allProject2.default,
  card: _card2.default,
  favorites: _favorites2.default,
  info: _info2.default,
  logOut: _logOut2.default,
  members: _members2.default,
  myProject: _myProject2.default,
  bell: _bell2.default,
  gear: _gear2.default,
  user: _user2.default,
  checkFilled: _CheckIconFilled2.default,
  logoTextOnly: _LogoTextOnly2.default,
  noProjects: _NoProjectsIcon2.default,
  wallet: _WalletIcon2.default,
  loupe: _LoupeIcon2.default,
  handBag: _HandBag2.default,
  like: _LikeIcon2.default,
  star: _StarIcon2.default,
  dashboard: _dashboard2.default
};